import React, { useState } from "react";
import {
  FaSearch,
  FaUserPlus,
  FaEye,
  FaEdit,
  FaPlus,
  FaCreditCard,
  FaTimes,
  FaChartLine,
} from "react-icons/fa";
import { Spin, message } from "antd";
import moment from "moment";
import { Base64 } from "js-base64";
import { Buffer } from "buffer";
import sha256 from "crypto-js/sha256";
import PaymentService from "../../../Services/PaymentService";
import DietVitalsTrends from "./DietVitalsTrends";

const DietPatientTable = ({
  loading,
  filteredPatients,
  searchTerm,
  setSearchTerm,
  handleView,
  handleEdit,
  onAddNewPlan,
  onAssignQuickPlan,
}) => {
  const [payModalOpen, setPayModalOpen] = useState(false);
  const [payPatient, setPayPatient] = useState(null);
  const [amount, setAmount] = useState("");
  const [processingPay, setProcessingPay] = useState(false);
  const [trendsModalOpen, setTrendsModalOpen] = useState(false);
  const [trendsPatient, setTrendsPatient] = useState(null);
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loggedUser = storedLoginResult ? JSON.parse(storedLoginResult) : null;

  const handlePayClick = (patient) => {
    setPayPatient(patient);
    setAmount(patient.amount || "");
    setPayModalOpen(true);
  };

  const handleTrendsClick = (patient) => {
    setTrendsPatient(patient);
    setTrendsModalOpen(true);
  };

  const handleDigitalPayment = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      message.warning("Please enter a valid amount");
      return;
    }

    const storedLoginResult = sessionStorage.getItem("login_result");
    const loginResultObject = storedLoginResult
      ? JSON.parse(storedLoginResult)
      : null;

    if (!loginResultObject || !loginResultObject.user) {
      message.error("Session expired. Please log in again.");
      return;
    }

    setProcessingPay(true);

    try {
      const convertUTCDate = (date, format = "MM/DD/YYYY") => {
        const d = new Date();
        date = new Date(
          moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
            " " +
            d.getHours() +
            ":" +
            d.getMinutes(),
        );
        return moment(new Date(date)).utc().format(format);
      };

      let date = moment(new Date()).format("YYYYMMDDHHmmssSSS");
      let transactionId = "MT" + date;

      const patientId = payPatient.patientId;
      const serviceTransId = payPatient.id || 0;
      const mobileNumber =
        payPatient.patientMobile || payPatient.patientMobile || "";
      const totalAmount = parseFloat(amount);

      let appointmentDetails =
        transactionId +
        "|" +
        patientId +
        "|" +
        loginResultObject.user.userId +
        "|" +
        serviceTransId +
        "|" +
        loginResultObject.user.account_Id +
        "|" +
        loginResultObject.user.clinic_Id;

      let base64string = Base64.encode(appointmentDetails);

      let paymentPayload = {
        merchantTransactionId: transactionId,
        amount: totalAmount * 100,
        redirectUrl: `${process.env.REACT_APP_BASEURL}dietphonepepayment/${base64string}`,
        redirectMode: "POST",
        callbackUrl: `${process.env.REACT_APP_API_BASEURL}phonePeResponse1/paymentCallBackDetails`,
        mobileNumber: mobileNumber,
        paymentInstrument: {
          type: "PAY_PAGE",
        },
      };

      const SALT_KEY = process.env.REACT_APP_PHONEPE_SALT_KEY;
      let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
      let base64EncodedPayload = bufferObj.toString("base64");
      let string = base64EncodedPayload + "/pg/v1/pay" + SALT_KEY;
      let sha256_val = sha256(string);
      let xVerifyChecksum = sha256_val + "###" + 1;

      let phonepeTransaction = {
        account_Id: loginResultObject.user?.account_Id,
        checksum: xVerifyChecksum,
        clinic_id: loginResultObject.user?.clinic_Id,
        createdBy: loginResultObject.user.userId,
        createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        paidDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        modifiedBy: loginResultObject.user.userId,
        patientId: patientId,
        enoCodePayload: base64EncodedPayload,
        providerreferenceId: "",
        serviceCode: "DIET_CHART",
        serviceName: "Diet Chart",
        status: 1,
        serviceTransId: serviceTransId,
        transactionId: transactionId,
        userId: loginResultObject.user.userId,
        amount: totalAmount,
        paymentType: "Digital",
      };

      const res = await PaymentService.PhonepeTransaction(phonepeTransaction);

      if (res.data === 1) {
        let billingTransaction = {
          account_Id: loginResultObject.user?.account_Id,
          amount: totalAmount,
          clinic_id: loginResultObject.user?.clinic_Id,
          createdBy: loginResultObject.user.userId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          discountAmount: 0,
          discountPercentage: 0,
          gst: 0,
          modifiedBy: loginResultObject.user.userId,
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidAmount: totalAmount,
          patientId: patientId,
          paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paymode: "PhonePe",
          serviceCode: "",
          serviceCost: totalAmount,
          serviceName: "",
          serviceTransId: serviceTransId,
          status: 0,
          transactionId: transactionId,
          userId: loginResultObject.user.userId,
          billingTransactionServices: [],
        };

        let array1 = {
          account_Id: loginResultObject.user?.account_Id,
          amount: totalAmount,
          clinic_id: loginResultObject.user?.clinic_Id,
          createdBy: loginResultObject.user.userId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedBy: loginResultObject.user.userId,
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidAmount: totalAmount,
          patientId: patientId,
          paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paymode: "PhonePe",
          serviceCode: "DIET_CHART",
          serviceCost: totalAmount,
          serviceName: "Diet Chart",
          serviceTransId: serviceTransId,
          status: 0,
          toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          transactionId: transactionId,
          userId: loginResultObject.user.userId,
        };
        billingTransaction.billingTransactionServices.push(array1);

        const billingRes =
          await PaymentService.BillingTransaction(billingTransaction);

        if (billingRes.data === 1) {
          let initiatePayload = {
            merchantOrderId: transactionId,
            amount: totalAmount * 100,
            expireAfter: 1200,
            metaInfo: {
              udf1: "Diet chart",
            },
            redirectUrl: `${process.env.REACT_APP_BASEURL}dietphonepepayment/${base64string}`,
          };
          let result = await PaymentService.V2initiatePayment(initiatePayload);
          window.location.replace(result.data.redirectUrl);
        } else {
          message.error("Failed to initialize billing transaction.");
        }
      } else {
        message.error("Failed to record PhonePe transaction.");
      }
    } catch (error) {
      console.error("An error occurred during payment initiation:", error);
      message.error("An error occurred. Please try again.");
      setProcessingPay(false);
    }
    // finally {
    //         setProcessingPay(false);

    // }
  };
  return (
    <div className="w-full">
      <div className="flex items-center justify-start mb-5">
        <div className="relative w-96">
          <input
            type="text"
            placeholder="Search Patient..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full py-3 border border-gray-300 rounded-lg px-4 pr-12 text-sm outline-none placeholder:text-gray-400 focus:border-[#159da8] transition-colors"
          />
          <FaSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-[18px]" />
        </div>
      </div>

      <div className="border border-gray-200 overflow-x-auto overflow-y-auto max-h-[600px] scrollwidth relative">
        <Spin
          spinning={loading}
          tip="Processing..."
          className="diet-table-spinner"
        >
          <table className="min-w-[1500px] w-full border-collapse">
            <thead className="sticky top-0 z-[1] shadow-sm">
              <tr className="bg-[#eafff8] text-[#4f5665]">
                <th className="text-left px-4 py-4 text-sm font-bold">
                  Patient Details
                </th>
                <th className="text-left px-4 py-4 text-sm font-bold">
                  Diet Plan
                </th>
                <th className="text-left px-4 py-4 text-sm font-bold">
                  From Date
                </th>
                <th className="text-left px-4 py-4 text-sm font-bold">
                  To Date
                </th>
                <th className="text-left px-4 py-4 text-sm font-bold">
                  Amount
                </th>
                <th className="text-left px-4 py-4 text-sm font-bold">
                  Payment Status
                </th>
                <th className="text-left px-4 py-4 text-sm font-bold">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredPatients.length > 0 ? (
                filteredPatients.map((p, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 text-[#4c5668]"
                  >
                    <td className="px-4 py-4 text-sm">
                      <div className="flex flex-col">
                        <span className="font-semibold text-gray-800">
                          {p.patientName || p.name}
                        </span>
                        <span className="text-[10px] text-gray-400 font-semibold">
                          {p.patientId}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm font-medium text-[#0b9ca8]">
                      {p?.chartTitle}
                    </td>
                    <td className="px-4 py-4 text-sm">
                      {p.fromDate || p.startDate || "NA"}
                    </td>
                    <td className="px-4 py-4 text-sm">
                      {p.toDate || p.endDate || "NA"}
                    </td>
                    <td className="px-4 py-4 text-sm">
                      {p.paymentRequiredYN === "Y" ? (
                        <span className="font-semibold text-gray-800">{`${loggedUser?.user?.currencyCode || ""} ${p.amount ?? 0}`}</span>
                      ) : (
                        <span className="text-gray-400 font-medium">-</span>
                      )}
                    </td>
                    <td className="px-4 py-4 text-sm">
                      {p.paymentRequiredYN === "Y" ? (
                        p.paidStatus?.toUpperCase() === "PAID" ? (
                          <span className="px-2.5 py-1 text-xs font-bold text-green-700 bg-green-50 border border-green-200 rounded-full inline-flex items-center">
                            Paid
                          </span>
                        ) : (
                          <span className="px-2.5 py-1 text-xs font-bold text-amber-700 bg-amber-50 border border-amber-200 rounded-full inline-flex items-center">
                            Payment Pending
                          </span>
                        )
                      ) : (
                        <span className="px-2.5 py-1 text-xs font-bold text-gray-500 bg-gray-50 border border-gray-200 rounded-full inline-flex items-center">
                          Not Required
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-3 text-[#0b9ca8] text-[20px]">
                        <label onClick={() => handleView(p)}>
                          <FaEye className="cursor-pointer hover:scale-110 duration-200" />
                        </label>
                        <FaPlus
                          onClick={() => onAssignQuickPlan(p)}
                          className="cursor-pointer hover:scale-110 duration-200 text-blue-500"
                          title="Assign New Plan"
                        />
                        <FaEdit
                          onClick={() => handleEdit(p)}
                          className="cursor-pointer hover:scale-110 duration-200"
                        />
                        <FaChartLine
                          onClick={() => handleTrendsClick(p)}
                          className="cursor-pointer hover:scale-110 duration-200 text-purple-500"
                          title="View Trends"
                        />
                        {loggedUser.user.country == "IN" &&
                          p.paymentRequiredYN == "Y" &&
                          (!p.paidStatus ||
                            p.paidStatus.trim() == "" ||
                            p.paidStatus.toUpperCase() !== "PAID") && (
                            <FaCreditCard
                              onClick={() => handlePayClick(p)}
                              className="cursor-pointer hover:scale-110 duration-200 text-emerald-600"
                              title="Pay Diet Fee"
                            />
                          )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-10 text-gray-500">
                    {loading ? "" : "No patients found."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Spin>
      </div>

      {/* Pay Modal */}
      {payModalOpen && payPatient && (
        <div className="fixed inset-0 z-50 bg-black/55 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl border border-gray-100 flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
            {/* Header */}
            <div className="flex justify-between items-center border-b px-6 py-4 bg-white">
              <div>
                <h2 className="text-xl font-bold text-gray-800">
                  Diet Charge Payment
                </h2>
                <p className="text-xs text-gray-500 mt-0.5">
                  Collect payment for patient:{" "}
                  <span className="font-semibold text-[#159da8]">
                    {payPatient.patientName || payPatient.name}
                  </span>
                </p>
              </div>
              <button
                onClick={() => setPayModalOpen(false)}
                className="text-gray-400 hover:text-red-500 hover:bg-gray-100 p-2 rounded-full transition-all duration-200"
              >
                <FaTimes size={18} />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 bg-gray-50/50 space-y-4">
              <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm space-y-4">
                <div className="flex flex-col gap-1">
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Patient Name
                  </span>
                  <p className="text-sm font-bold text-gray-800 leading-none">
                    {payPatient.patientName || payPatient.name}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-50">
                  <div className="flex flex-col gap-1">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                      Patient ID
                    </span>
                    <p className="text-xs font-semibold text-gray-700">
                      {payPatient.patientId}
                    </p>
                  </div>
                  <div className="flex flex-col gap-1">
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                      Mobile Number
                    </span>
                    <p className="text-xs font-semibold text-gray-700">
                      {payPatient.patientMobile ||
                        payPatient.patientMobile ||
                        "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 ml-1">
                  {`Enter Payment Amount (${loggedUser?.user?.currencyCode || ""})`}
                </label>
                <div className="relative">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg font-semibold text-gray-400">
                    {loggedUser?.user?.currencyCode || ""}
                  </span>
                  <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="0.00"
                    className="w-full pl-8 pr-4 py-3 border border-gray-200 rounded-xl text-lg font-semibold outline-none focus:border-[#159da8] transition-all bg-white shadow-inner"
                    autoFocus
                  />
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="border-t px-6 py-4 bg-white flex justify-end gap-3">
              <button
                onClick={() => setPayModalOpen(false)}
                className="px-5 py-2.5 text-sm font-semibold text-black bg-white border border-gray-200 rounded-xl transition-colors hover:bg-gray-50"
                disabled={processingPay}
              >
                Cancel
              </button>
              <button
                onClick={handleDigitalPayment}
                disabled={processingPay || !amount || parseFloat(amount) <= 0}
                className="px-6 py-2.5 text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 disabled:bg-gray-300 disabled:shadow-none rounded-xl shadow-lg shadow-emerald-600/20 transition-all flex items-center gap-2"
              >
                {processingPay ? (
                  <>
                    <Spin size="small" /> Processing...
                  </>
                ) : (
                  <>
                    <FaCreditCard size={14} /> Digital Payment
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <DietVitalsTrends
        open={trendsModalOpen}
        onCancel={() => setTrendsModalOpen(false)}
        patient={trendsPatient}
      />
    </div>
  );
};

export default DietPatientTable;
